import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { showRecruitmentPageContent } from '../../../services/recruitments';
import { getCompanyProfileDetails } from '../../../services/companies';
import { RecruitmentPageContent, CompanyProfileDetails } from '../../../types/recruitmentShow';
import { RecruitmentShowContentProps as Props } from './types';
import { useDevice } from '../../../hooks/device';

export const Component: FunctionComponent<Props> = (props) => {
  const { isPc } = useDevice();
  const [contentState, setContentState] = useState<RecruitmentPageContent>({
    regularEmployee: false,
    employmentTypes: [],
    workingTime: '',
    workingPeriod: '',
    trialPeriod: '',
    address: '',
    occupationNames: [],
    salary: '',
    brands: '',
    salaryDetailPresent: false,
    salaryDetail: '',
    socialInsurances: [],
    welfares: [],
    welfareOtherPresent: false,
    welfareOther: '',
    updatedAt: '',
    what_todo_content_full: '',
    why_need_content_full: '',
    plannedHires: '',
    preferenceConditions: {
      features: [],
      candidateRequirements: [],
      workplaces: [],
      averageAges: [],
      genderRatios: [],
      workEnvironments: [],
      workStyles: [],
      holidaysVacations: [],
      dressCodeBenefits: [],
      compensationEvaluations: [],
      selectionConfigurations: [],
    }
  });
  const [companyState, setCompanyState] = useState<CompanyProfileDetails>({
    name: '',
    shihonkin: '',
    setsuritsunengetsu: '',
    daihyoshaname: '',
    jugyoinsu: '',
    honshashozaichi: '',
    industries: [],
    url: '',
  });

  useEffect(() => {
    fetchContentDetails();
    fetchCompanyDetails();
  }, []);

  const fetchContentDetails = async () => {
    try {
      const response = await showRecruitmentPageContent(props.recruitmentId);
      setContentState(response);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCompanyDetails = async () => {
    try {
      const response = await getCompanyProfileDetails(props.companyId);
      setCompanyState(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Presentation
      {...props}
      isPc={isPc}
      contentState={contentState}
      companyState={companyState}
    />
  );
};
